import Glide from '@glidejs/glide';
import {utilities} from "./utilities";

class KbBSSite {
    sliders = document.querySelectorAll('.glide');
    glideCarousels = [];

    run () {
        this.mountGlideSliders();
    }

    mountGlideSliders() {
        let autoplay = 4000;
        let hoverpause = false;
        let perView = 1;
        let perViewMobile = 1;
        let displayType = 'slider';

        if (this.sliders.length > 0) {
            this.sliders.forEach(elem => {
                autoplay = elem.dataset.autoplay === undefined ? autoplay : (elem.dataset.autoplay === "false" ? false : elem.dataset.autoplay);
                hoverpause = elem.dataset.hoverpause === undefined ? hoverpause : elem.dataset.hoverpause;
                perView = elem.dataset.perView === undefined ? perView : elem.dataset.perView;
                perViewMobile = elem.dataset.perViewMobile === undefined ? perViewMobile : elem.dataset.perViewMobile;
                displayType = elem.dataset.displayType === undefined ? displayType : elem.dataset.displayType;

                let glider = new Glide(elem, {
                    type: displayType,
                    autoplay: autoplay,
                    hoverpause: hoverpause,
                    perView: perView,
                    breakpoints: {
                        991: {
                            perView: perViewMobile
                        }
                    }
                }).mount();

                this.glideCarousels.push(glider);
            }, this);
        }
    }
}

const site = new KbBSSite();
site.run();

function setVw() {
    let vw = document.documentElement.clientWidth / 100;
    document.documentElement.style.setProperty('--vw', `${vw}px`);

    if (site.glideCarousels.length > 0) {
        site.glideCarousels.forEach(function(elem, idx) {
            elem.mount();
        });
    }
}

setVw();
window.addEventListener('resize', setVw);